var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotebook2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/education/notebook_2_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00033 1.33337C3.26395 1.33337 2.66699 1.93033 2.66699 2.66671V13.3334C2.66699 14.0698 3.26395 14.6667 4.00033 14.6667H11.3337C12.4383 14.6667 13.3337 13.7713 13.3337 12.6667V3.33337C13.3337 2.22881 12.4383 1.33337 11.3337 1.33337H4.00033ZM6.66699 2.66671H4.00033V13.3334H11.3337C11.7019 13.3334 12.0003 13.0349 12.0003 12.6667V3.33337C12.0003 2.96519 11.7019 2.66671 11.3337 2.66671H10.667V8.65064C10.667 9.25044 9.94172 9.55091 9.51752 9.12671L8.66699 8.27617L7.81646 9.12671C7.39226 9.55091 6.66699 9.25051 6.66699 8.65064V2.66671ZM9.33366 2.66671H8.00033V7.05724L8.19086 6.86671C8.45379 6.60373 8.88013 6.60373 9.14313 6.86671L9.33366 7.05724V2.66671Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook2Line);
export default __webpack_public_path__ + "static/media/notebook_2_line.fe4525d47f0a5ac6327544c120e534d0.svg";
export { ForwardRef as ReactComponent };